import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transfer-authorization-form',
  templateUrl: './transfer-authorization-form.component.html',
  styleUrls: ['./transfer-authorization-form.component.css']
})
export class TransferAuthorizationFormComponent implements OnInit {

  title="Transfer Authorization";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/transfer/transfer-authorization/transfer-authorization-form/transfer-authorization-form.component.ts